"use client";

import { c as _c } from "react/compiler-runtime";
import { DatePicker, useDatepicker } from "@navikt/ds-react";
import { logAnalyticsEvent } from "@/common/analytics/logAnalyticsEvent";
import { toDateStringInIsoFormat } from "@/utils/dateAndTime/dateUtils";
import { useFieldContext } from "../hooks/form-context";
interface Props {
  label: string;
  description?: React.ReactNode;
  fromDate: Date;
  toDate: Date;
  isRequired: boolean;
  isChangeDisabled?: boolean;
  isReadOnly?: boolean;
  className?: string;
}
export default function FormDatePicker(t0) {
  const $ = _c(17);
  const {
    label,
    description,
    fromDate,
    toDate,
    isRequired,
    isChangeDisabled: t1,
    isReadOnly: t2,
    className
  } = t0;
  const isChangeDisabled = t1 === undefined ? false : t1;
  const isReadOnly = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[0] !== field.state.value) {
    t3 = field.state.value ? new Date(field.state.value) : undefined;
    $[0] = field.state.value;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    datepickerProps,
    inputProps
  } = useDatepicker({
    fromDate,
    toDate,
    allowTwoDigitYear: false,
    defaultSelected: t3,
    onDateChange: date => {
      if (!isChangeDisabled && date) {
        const dateIsoString = toDateStringInIsoFormat(date);
        logAnalyticsDatoValgt(dateIsoString);
        field.handleChange(dateIsoString);
      }
    }
  });
  let t4;
  if ($[2] !== field.state.meta.errors) {
    t4 = field.state.meta.errors.map(_temp).join(", ");
    $[2] = field.state.meta.errors;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const errorMessages = t4;
  function logAnalyticsDatoValgt(datoVerdi) {
    logAnalyticsEvent({
      name: "dato valgt",
      properties: {
        datoFelt: label,
        datoVerdi
      }
    });
  }
  let t5;
  if ($[4] !== className || $[5] !== description || $[6] !== errorMessages || $[7] !== field.handleBlur || $[8] !== field.name || $[9] !== inputProps || $[10] !== isReadOnly || $[11] !== isRequired || $[12] !== label) {
    t5 = <DatePicker.Input {...inputProps} id={field.name} onBlur={field.handleBlur} label={label} description={description} error={errorMessages} className={className} readOnly={isReadOnly} aria-required={isRequired} />;
    $[4] = className;
    $[5] = description;
    $[6] = errorMessages;
    $[7] = field.handleBlur;
    $[8] = field.name;
    $[9] = inputProps;
    $[10] = isReadOnly;
    $[11] = isRequired;
    $[12] = label;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== datepickerProps || $[15] !== t5) {
    t6 = <DatePicker {...datepickerProps}>{t5}</DatePicker>;
    $[14] = datepickerProps;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(err) {
  return err?.message;
}